<template>
    <div @keyup.enter="gotoIndex" tabindex="0">
        <div class="home-conten" v-show="showHome">
            <div class="home-main">
                <div v-if="true">
                    <div :class="height768?'home-main-img768':moreHeight?'home-main-img2':'home-main-img'">
                        <Alert banner closable type="success" :style="{display:isShowBanner?'block':'none'}">{{banerContent}}</Alert>
                        <div style="position:fixed;bottom: 50px;left:50%;cursor:pointer;" @click="openQR"><img id="qrimg" style="width:60px;height: 60px;" src="../assets/images/mobileqrcode.png"></div>
                        <div :class="height768?'my-Btn2':moreHeight?'my-Btn':'my-Btn'" @click="gotoIndex">进入主页</div>
                    </div>
                </div>
                <div v-else>
                </div>
            </div>
            <div class="home-foot">
                <div type="text" style="box-shadow:none;" size="small" ghost> Copyright © 2020 www.holywiser.com 众智云擎 版权所有 | <a @click="statement">特别声明</a> | <a href="http://beian.miit.gov.cn/" target="_black">蜀ICP备20000433号-1</a> | <span style="color:#BBBBBB;">服务热线：028-66612366</span></div>
            </div>
        </div>
        <Modal v-model="modalStateMent" width="500" :mask-closable="false">
            <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
                <!--  <Icon type="ios-paper" size="18" /> -->
                <span>特别声明</span>
            </p>
            <div style="height:400px;overflow-y: auto;">
                <Statement ref="statementContent"></Statement>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="closeStateMent">我知道了</Button>
                <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
            </div>
        </Modal>
        <Modal v-model="isShowQRCode" width="500" :mask-closable="true" :closable="false">
            <div>
                <Card :bordered="false">
                    <div style="text-align:center">
                        <img src="../assets/images/mobileqrcode.png">
                        <h3>扫码进入移动云擎</h3>
                    </div>
                </Card>
            </div>
            <div slot="footer" style="text-align: center;">
                <Button type="primary" size="large" @click="closeQR">关闭</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import statement from './stateMent.vue'
export default {
    name: "homepage",
    data() {
        return {
            moreHeight: false,
            modalStateMent: false,
            height768: false,
            isShowBanner: true,
            banerContent: "",
            isShowQRCode: false,
            showHome: false,
        }
    },
    beforeCreate() {
        let count = 0;
        let imgs = [
            require('../assets/images/backpage.jpg'),
            require('../assets/images/back2.jpg'),
            require('../assets/images/backpage.jpg')
        ]
        for (let img of imgs) {
            let image = new Image();
            image.src = img;
            image.onload = () => {
                console.log('loading img' + count)
                count++;
                if (count > 2) {
                    this.bgroundReady()
                }
                
            };

        }

    },
    methods: {
        loadEchat() {
            var echat = document.createElement('script');
            echat.type = 'text/javascript';
            echat.async = true;
            echat.id = 'echatmodulejs';
            echat.setAttribute('charset', 'UTF-8');
            echat.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.echatsoft.com/visitor/echat.js';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(echat, s);
        },
        bgroundReady() {
            console.log('bgroundReady=======>')
            this.showHomeBG()
        },
        openQR() {
            this.isShowQRCode = true
        },
        closeQR() {
            this.isShowQRCode = false
        },
        initSysMsg() {
            this.isShowBanner = this.$baseConfig.isShowBanner
            this.banerContent = decodeURIComponent(this.$baseConfig.msg)
        },
        stopBanner() {
            // setTimeout(() => {

            // }, 1000 * 60)
        },
        gotoIndex() {
            this.$router.push('localsearch')
        },
        gotest(){
            this.$router.push('test')
        },
        statement() {
            this.modalStateMent = true
        },
        closeStateMent() {
            this.modalStateMent = false
        },
        go(ev) {
            console.log(ev)
        },
        handleSpinCustom() {
            this.$Spin.show({
                render: (h) => {
                    return h('div', [
                        h('Icon', {
                            'class': 'demo-spin-icon-load',
                            props: {
                                type: 'ios-loading',
                                size: 18
                            }
                        }),
                        h('div', {
                            domProps: {
                                style: 'font-size:14px;font-weight:bold;',
                            }
                        }, '众智云擎加载中...')
                    ])
                }
            });

        },
        showHomeBG() {
            this.$Spin.hide();
            this.showHome = true
            this.loadEchat()
        }
    },
    created() {
        this.handleSpinCustom()
        console.log("分辨率:" + window.screen.width + "*" + window.screen.height)
        if (window.screen.height > 1080) {
            this.moreHeight = true
        }

        if (window.screen.height <= 768) {
            this.height768 = true
        }
        this.initSysMsg()


    },
    mounted() {
        // this.$nextTick(function() {
        //     setTimeout(() => {
        //         this.bgroundReady()
        //     }, 1000);
        // })
    },
    components: {
        "Statement": statement,
    }

}
</script>
<style lang="less" scoped>
// :root{
//     --mar-bg-color:red;
// }
.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

// 控制加载背景色
.ivu-spin-fullscreen .ivu-spin-fix {
    background: #dee;
}

.demo-spin-loading {
    opacity: 1.0;
    background: green;
}

.home-conten {
    height: 100%;
    /* display: flex;
  flex-direction: column; */
}

.home-main {
    /* flex: 1; */
    /*margin: 0px 10% 10px 10%;*/
    min-height: 920px;
}

.home-main-img {
    min-height: 920px;
    background-image: url('../assets/images/backpage.jpg');
    //background-image: url('https://bing.oneneko.com/image/WhangareiFalls_ZH-CN9150162556_1920x1080.jpg');
    background-repeat: no-repeat;
    /*background-size:auto 100%;*/
}

.home-main-img2 {
    min-height: 900px;
    background-image: url('../assets/images/back2.jpg');
    //background-image: url('https://bing.oneneko.com/image/WhangareiFalls_ZH-CN9150162556_1920x1080.jpg');
    background-repeat: no-repeat;
    /*background-size:auto 100%;*/
}

.home-main-img768 {
    min-height: 900px;
    background-image: url('../assets/images/back768.jpg');
    background-repeat: no-repeat;
    /*background-size:auto 100%;*/
}

.home-foot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 50px;
    text-align: center;
    line-height: 50px;
    background: #515a6e;
    color: #d1d1d1;
}

.my-Btn {
    background-image: linear-gradient(to right, #50fce2, #1aa6ff);
    position: absolute;
    left: 360px;
    top: 630px;
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    border-radius: 50px;
    cursor: pointer;
    color: #fff;
    font-weight: 600;
    letter-spacing: 4px;
}

.my-Btn2 {
    background-image: linear-gradient(to right, #50fce2, #1aa6ff);
    position: absolute;
    left: 170px;
    top: 118px;
    width: 160px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    border-radius: 50px;
    cursor: pointer;
    color: #fff;
    font-weight: 600;
    letter-spacing: 4px;
}

#qrimg:hover {
    border: 1px solid #ff9900;
}
</style>